var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA3WallLampOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20h-4v-6h4v6zm13.22 2.28l-2.83-2.83-4.24 4.24L49 26.52l4.22-4.24zM30 23.69l-4.24-4.24-2.83 2.83 4.24 4.24L30 23.69zM38 28c-8.58 0-15.56 5.32-16 12h32c-.44-6.68-7.42-12-16-12zM69 7v62H7V7h62zm-4 4H11v46h18.88a6.31 6.31 0 006.3-6h-3.12l-2-8h14l-2 8h-2.89a10.32 10.32 0 01-10.3 10H11v4h54V11z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A3_Wall_lamp_on.27d5de1e.svg";
export { SvgA3WallLampOn as ReactComponent };